import Send from '@/config/api/index'

const swarmPath = "/v1/swarm"

function swarmApi(api, params, config) {
    return Send.post(swarmPath + api, params, config)
}

export default {
    listServicesWithTasks(params) {
        return swarmApi('/services/with-tasks', params);
    },
    // 서비스 관련 API
    listServices(params) {
        return swarmApi('/services', params)
    },
    listServiceTasks(params, config) {
        return swarmApi('/service/tasks', params, config);
    },
    inspectService(params, config) {
        return swarmApi('/service/inspect', params, config);
    },
    updateServiceImage(params) {
        return swarmApi('/service/update', params);
    },
    forceUpdateService(params) {
        return swarmApi('/services/update/force', params);
    },


    scaleService(params) {
        return swarmApi('/service/scale', params)
    },

    // 노드 관련 API
    listNodes(params) {
        return swarmApi('/nodes', params)
    },
}